module.exports = __webpack_public_path__ + "static/media/FREERIDER-RF-5400-iQ.fa241f87.png";